import { motion } from 'framer-motion';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen min-h-[800px] flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          poster="https://public.readdy.ai/ai/img_res/3e38f38cd6aacc50705cd281e19e4978.jpg"
        >
          <source src="https://cdn.coverr.co/videos/coverr-pouring-concrete-8603/1080p.mp4" type="video/mp4" />
        </video>
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="text-6xl lg:text-7xl xl:text-8xl font-black text-white mb-4 tracking-tight">
            BUILDING FOUNDATIONS
          </h1>
          <p className="font-serif italic text-5xl lg:text-6xl xl:text-7xl text-white/90 mb-6">
            That Last Forever
          </p>
          <p className="text-xl lg:text-2xl text-white font-light mb-12 max-w-2xl mx-auto">
            Premium Concrete Solutions in Warsaw, Indiana
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">
            <button
              onClick={scrollToContact}
              className="bg-black text-white px-10 py-4 rounded-full text-base font-semibold hover:bg-black/90 transition-all w-full sm:w-auto whitespace-nowrap cursor-pointer"
            >
              GET FREE QUOTE
            </button>
            <a
              href="#gallery"
              className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-black transition-all w-full sm:w-auto whitespace-nowrap cursor-pointer inline-block text-center"
            >
              VIEW PROJECTS
            </a>
          </div>

          {/* Badge */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-shield-check-fill text-2xl text-brand-green"></i>
            </div>
            <span className="text-white font-medium text-sm whitespace-nowrap">Licensed & Insured LLC</span>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1, repeat: Infinity, repeatType: 'reverse' }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </motion.div>
    </section>
  );
};

export default HeroSection;